export const NAMESPACES = {
  PAGES: 'pages',
  PROVIDER: 'provider',
  CATEGORY: 'category',
  THEME: 'theme',
  ERROR: 'error',
  EVA: 'eva',
  GAME: 'game',
  INITIAL: 'initial',
  SLIDER: 'slider',
  TAG: 'tag',
  SEO_TEXTS: 'seotexts',
  BONUS: 'bonus',
  MAINTENANCE: 'maintenance',
  META_TAGS: 'metatags',
  HALL_OF_FAME: 'halloffame',
};
